import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
    try {
      window.localStorage.setItem('i18nextLng', newLang);
    } catch (_) {
      // ignore storage errors
    }
  };

  return (
    <div className="mt-2">
      <label className="sr-only" htmlFor="lang-select">Language</label>
      <select
        id="lang-select"
        value={i18n.language?.slice(0,2) || 'en'}
        onChange={handleChange}
        className="block w-full text-xs px-2 py-1 border border-gray-300 rounded-lg bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
      >
        <option value="en">English</option>
        <option value="es">Español</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;


